package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.request_model.InitialInspectionRequest
import kz.dentalcrm.app.data.network.response_model.initial_inspection.InitialInspectionType

class InitialInspectionApi(
    private val httpClient: HttpClient,
    private val storage: Storage,
) {

    suspend fun getInitialInspections(appointmentId: Int) =
        httpClient.handle<List<InitialInspectionType>> {
            contentType(ContentType.Application.Json)
            url {
                headers {
                    header("Authorization", "Bearer ${storage.getAccessToken()}")
                }
                path("api/v1/appointments/$appointmentId/initial-inspections")
            }
            method = HttpMethod.Get
        }

    suspend fun toggleInitialInspection(request: InitialInspectionRequest) =
        httpClient.handle<Any?> {
            contentType(ContentType.Application.Json)
            url {
                headers {
                    header("Authorization", "Bearer ${storage.getAccessToken()}")
                }
                path("api/v1/initial-inspections")
                setBody(request)
            }
            method = HttpMethod.Post
        }
}
